<div>
	<div class="row">
		<div class="col"></div>
		<div class="col-auto">
			<button type="button" class="btn btn-primary" [routerLink]="['/Asset/assetTransfer/add/',0]"
				[disabled]="isDisabled">
				<i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
					*ngIf="isDisabled"></span>
				{{!isDisabled?'Asset Transfer':'Loading...'}}
			</button>
		</div>
	</div>
	<div class="card border-radius-0 mt-1 p-0">
		<div class="card-header">
			Asset Transfer
		</div>
		<div class="card-body p-1">
			<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
				<thead class="table-light">
					<tr>
						<th scope="col" style="width: 5px;">#</th>
						<th>Asset Name</th>
						<th>Asset Code</th>
						<th>Serial Number</th>
						<th>Assign Date</th>
						<th>Allotment From Type</th>
						<th>Allotment To Type</th>
						<th style="width: 5px;">Action</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let TableData of TableDatas; let i = index">
						<th scope="row" style="width: 5px;">{{i+1}}</th>
						<td>{{TableData['AssetMasterName']}}</td>
						<td>{{TableData['AssetNumber']}}</td>
						<td>{{TableData['SerialNumber']}}</td>
						<td>{{TableData['AssignDate'] | date: 'dd MMM yyyy'}}</td>
						<td>{{TableData['AllotmentFromType']}}</td>
						<td>{{TableData['AllotmentToType']}}</td>
						<td style="width: 5px;">
							<div class="text-center"><i
									[routerLink]="['/Asset/assetmaster/add/',TableData['ESS_AssetMasterId']]"
									class="bi bi-pencil-square text-warning"></i></div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>